module.exports = __webpack_public_path__ + "img/Group15.a68376eb.png";